import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Moment from 'react-moment';
import 'moment/locale/pt-br';
import AdvancedFilter from './AdvancedFilter';
import DownloadBatch from '../../components/Components/DownloadBatch';
import Download from '../../components/Components/Download';

import {
    Input,
    Button,
    Table,
    Menu,
    Icon,
    Dropdown,
    Modal,
    Popover,
    Badge,
    Select
} from 'antd';
import FilterPillsBar from '~/_shared/components/FilterPillsBar';
import MonthInput from '~/_shared/components/MonthInput';
import RestoredFiltersNotice from '~/_shared/components/RestoredFiltersNotice';

import {
    TopBar,
    Cod
} from '~/components/UI';
import * as drawerRefundsActions from '../DrawerRefunds/actions';
import * as refundsActions from './actions';

import { toBRL } from '~/components/UI/InputCurrency';
import { PERMISSIONS } from '~/constants/permissions.constants';
import { ModuleHeader, ModuleHeaderWrapper } from '~/components/ModuleHeader';
import { HeaderContainer, HeaderLeftContent, HeaderRightContent } from './styles';
import { getDefaultPaginationConfig } from '~/utils/get-default-pagination-config';
import { STORAGE } from '~/constants/storage.constants';
import {
    FILTER_BY_OPTIONS,
    STATUS_OPTIONS,
    normalizeRefundsPeriod,
    isRefundsPeriodDefault,
    getRefundsPeriodLabel,
    getFilterByLabel,
    getStatusLabel,
    countActiveRefundsFilters,
    filterRefundsBySearch,
} from './helpers';

var SearchInput = Input.Search;
var Column = Table.Column;
var Option = Select.Option;

const payment_method = (val) =>{
    switch(val){
      case 1: return 'Dinheiro';
      case 2: return 'Boleto';
      case 3: return 'Cartão';
      case 4: return 'Transferência';
      case 5: return 'Pix';
      case 6: return 'Depósito';
      case 7: return 'Cheque';
    }
}

const RefundsList = (props) => {

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    // Applied filters live in the screen (usePersistedFilters), which reloads
    // the list whenever filter by / period / status change.
    var persisted = props.persisted;
    var applied = persisted.filters;
    var setApplied = persisted.setFilters;
    var defaults = persisted.defaults;
    var search = applied.search || '';
    var filterBy = applied.filterBy;
    var statusFilter = applied.status;

    // Draft fields in the popover; only take effect on "Filtrar" / Enter.
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [draftFilterBy, setDraftFilterBy] = useState(applied.filterBy);
    const [draftFrom, setDraftFrom] = useState(applied.from);
    const [draftTo, setDraftTo] = useState(applied.to);

    var handleFiltersOpenChange = useCallback(function(open) {
        if (open) {
            setDraftFilterBy(applied.filterBy);
            setDraftFrom(applied.from);
            setDraftTo(applied.to);
        }
        setFiltersOpen(open);
    }, [applied.filterBy, applied.from, applied.to]);

    var handleApplyFilter = function(overrides) {
        var period = normalizeRefundsPeriod(
            (overrides && overrides.from) || draftFrom,
            (overrides && overrides.to) || draftTo
        );
        if (!period) return;
        setApplied({ filterBy: draftFilterBy, from: period.from, to: period.to });
        setFiltersOpen(false);
    };

    var handleClearFilters = function() {
        persisted.resetFilters();
        setFiltersOpen(false);
    };

    var isPeriodDefault = isRefundsPeriodDefault(applied, defaults);

    const { 
        user, 
        showDrawerRefunds,
        setPaid,
        data,
        isLoading
    } = props;

    const handleMenu = (key, item) => {
        switch(key){
            case 'edit': showDrawerRefunds(item); break;            
            case 'paid': 
                Modal.confirm({
                    title: `Você realmente deseja alterar esta comissão para ${item.refund.type? 'Recebido':'Pago'}?`,
                    content: 'Esta ação não poderá ser desfeita.',
                    okText: 'Sim',
                    okType: 'danger',
                    cancelText: 'Cancelar',
                onOk: () => setPaid(item.id)
              }); break;
            // default: `key: ${key} is not supported.`;
        }
    }

    const getFilename = (data) => {
          const now = moment(data.refund.apuration_at).format('MM-YYYY');
          return `${data.refund.responsible}_COMISSÃO_${now}.pdf`;      
    }

    let filtered = filterRefundsBySearch(data, search);

    const selectRow = (record) => {        
        if (selectedRowKeys.indexOf(record.id) >= 0) {
            setSelectedRowKeys((state) => state.filter((row) => row.id !== record.id));
        } else {
            setSelectedRowKeys((state) => [...state, record.id]);
        }
    }
    
    const onSelectedRowKeysChange = (keys) => {
        setSelectedRowKeys(keys)
    }

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectedRowKeysChange,
    };

    // Pills show the applied values; removing one resets only that filter, and
    // the screen reloads the list when a server-side filter changes.
    var pills = [{
        key: 'period',
        label: getRefundsPeriodLabel(applied),
        color: isPeriodDefault ? '#1890ff' : '#722ed1',
        icon: 'calendar',
        onRemove: isPeriodDefault ? undefined : function() { setApplied({ from: defaults.from, to: defaults.to }); },
    }];
    if (filterBy !== defaults.filterBy) {
        pills.push({ key: 'filterBy', label: getFilterByLabel(filterBy), color: '#722ed1', onRemove: function() { setApplied({ filterBy: defaults.filterBy }); } });
    }
    if (statusFilter !== defaults.status) {
        pills.push({ key: 'status', label: getStatusLabel(statusFilter), color: '#fa8c16', onRemove: function() { setApplied({ status: defaults.status }); } });
    }
    if (search) {
        pills.push({ key: 'search', label: 'Busca: ' + search, color: '#722ed1', icon: 'search', onRemove: function() { setApplied({ search: '' }); } });
    }

    var restoredSummary = pills
        .filter(function(pill) { return pill.key !== 'period' || !isPeriodDefault; })
        .map(function(pill) { return pill.label; })
        .join(' · ');

    return (
        <div>
            <ModuleHeaderWrapper>
                <ModuleHeader
                    breadcrumbs={['Financeiro', 'Comissões']}
                    title="Comissões"
                    search={
                        <SearchInput
                            placeholder="Pesquisar"
                            value={search}
                            onChange={function(e) { setApplied({ search: e.target.value }); }}
                            style={{ maxWidth: 300 }}
                        />
                    }
                    center={
                        <>
                            <Popover
                                trigger="click"
                                placement="bottomRight"
                                visible={filtersOpen}
                                onVisibleChange={handleFiltersOpenChange}
                                content={
                                    <div style={{ width: 560 }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                                            <span style={{ fontSize: 15, fontWeight: 600, color: '#262626' }}>Filtros</span>
                                            {!persisted.isDefault && (
                                                <a
                                                    style={{ fontSize: 12, color: '#f5222d' }}
                                                    onClick={handleClearFilters}
                                                >
                                                    Limpar tudo
                                                </a>
                                            )}
                                        </div>
                                        <div style={{ display: 'flex', gap: 20 }}>
                                            {/* Column 1: Filtrar por + Período */}
                                            <div style={{ flex: 1 }}>
                                                <div style={{ marginBottom: 14 }}>
                                                    <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Filtrar por</div>
                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                                                        {FILTER_BY_OPTIONS.map(function(opt) {
                                                            var isActive = draftFilterBy === opt.value;
                                                            return (
                                                                <div
                                                                    key={opt.value}
                                                                    onClick={function() {
                                                                        setDraftFilterBy(opt.value);
                                                                    }}
                                                                    style={{
                                                                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                                        padding: '8px 12px', borderRadius: 6, cursor: 'pointer',
                                                                        border: '1.5px solid ' + (isActive ? opt.color : '#e8e8e8'),
                                                                        background: isActive ? opt.color + '0a' : '#fafafa',
                                                                        transition: 'all 0.2s',
                                                                    }}
                                                                >
                                                                    <span style={{ fontSize: 13, fontWeight: isActive ? 600 : 400, color: isActive ? '#262626' : '#8c8c8c' }}>
                                                                        <Icon type={opt.icon} style={{ marginRight: 8 }} />
                                                                        {opt.label}
                                                                    </span>
                                                                    {isActive && <Icon type="check" style={{ color: opt.color, fontSize: 14 }} />}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Período</div>
                                                    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                                                        <MonthInput
                                                            value={draftFrom}
                                                            onChange={function(v) { setDraftFrom(v); }}
                                                            onPressEnter={function(v) { handleApplyFilter({ from: v }); }}
                                                            style={{ flex: 1 }}
                                                        />
                                                        <span style={{ color: '#8c8c8c', lineHeight: '32px' }}>-</span>
                                                        <MonthInput
                                                            value={draftTo}
                                                            onChange={function(v) { setDraftTo(v); }}
                                                            onPressEnter={function(v) { handleApplyFilter({ to: v }); }}
                                                            style={{ flex: 1 }}
                                                        />
                                                    </div>
                                                    <div style={{ fontSize: 11, color: '#bfbfbf', marginTop: 4 }}>
                                                        Digite o mês (ex.: 03/2026) ou use o calendário. Enter aplica.
                                                    </div>
                                                </div>
                                                <Button type="primary" block style={{ marginTop: 14 }} onClick={function() { handleApplyFilter(); }}>
                                                    Filtrar
                                                </Button>
                                            </div>
                                            {/* Column 2: Status */}
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Status</div>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                                                    {STATUS_OPTIONS.map(function(opt) {
                                                        var isActive = statusFilter === opt.value;
                                                        return (
                                                            <div
                                                                key={opt.value}
                                                                onClick={function() {
                                                                    // Status applies right away (the screen reloads the list).
                                                                    setApplied({ status: opt.value });
                                                                }}
                                                                style={{
                                                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                                    padding: '8px 12px', borderRadius: 6, cursor: 'pointer',
                                                                    border: '1.5px solid ' + (isActive ? opt.color : '#e8e8e8'),
                                                                    background: isActive ? opt.color + '0a' : '#fafafa',
                                                                    transition: 'all 0.2s',
                                                                }}
                                                            >
                                                                <div>
                                                                    <div style={{ fontSize: 13, fontWeight: isActive ? 600 : 400, color: isActive ? '#262626' : '#8c8c8c' }}>
                                                                        <span style={{ width: 8, height: 8, borderRadius: '50%', background: opt.color, display: 'inline-block', marginRight: 8 }} />
                                                                        {opt.label}
                                                                    </div>
                                                                    <div style={{ fontSize: 11, color: '#8c8c8c', marginTop: 2, marginLeft: 16 }}>{opt.desc}</div>
                                                                </div>
                                                                {isActive && <Icon type="check" style={{ color: opt.color, fontSize: 14 }} />}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            >
                                <Badge
                                    count={countActiveRefundsFilters(applied, defaults)}
                                    offset={[-4, 0]}
                                    style={{ backgroundColor: '#722ed1' }}
                                >
                                    <Button icon="bars" style={{ borderRadius: 8 }}>Filtros</Button>
                                </Badge>
                            </Popover>
                            <Dropdown
                                trigger={['click']}
                                overlay={
                                    <Menu>
                                        <Menu.Item key="new" onClick={function() { showDrawerRefunds(); }}>
                                            <Icon type="plus" /> Cadastrar Comissão
                                        </Menu.Item>
                                        <Menu.Divider />
                                        <Menu.Item key="print" disabled={selectedRowKeys.length === 0}>
                                            <DownloadBatch
                                                url="/refunds/payments/print/batch"
                                                filename="comissão.zip"
                                                ids={selectedRowKeys}
                                            >
                                                <span><Icon type="printer" /> Imprimir selecionados</span>
                                            </DownloadBatch>
                                        </Menu.Item>
                                    </Menu>
                                }
                            >
                                <Button icon="plus" shape="circle" />
                            </Dropdown>
                        </>
                    }
                    advanced={
                        <FilterPillsBar
                            pills={pills}
                            onClearAll={persisted.isDefault ? undefined : handleClearFilters}
                        />
                    }
                />
            </ModuleHeaderWrapper>
            <RestoredFiltersNotice
                visible={persisted.wasRestored}
                summary={restoredSummary}
                onReset={handleClearFilters}
                onDismiss={persisted.dismissRestored}
            />
            <div className="table-clabs">
                <Table 
                    rowKey="id"
                    dataSource={filtered}
                    loading={isLoading} 
                    pagination={getDefaultPaginationConfig({
                        storageKey: STORAGE.defaultPageSize.refunds
                    })}
                    bordered={true}
                    rowClassName="row-clabs"
                    scroll={{ x: 1990, y: `${window.innerHeight-175}px`}}
                    rowSelection={rowSelection}
                    onRow={record => ({
                    onClick: () => {
                        selectRow(record);
                    }
                    })}
                >
                    <Column
                        title="Status"
                        dataIndex="status"
                        key="status"
                        width={120}
                        fixed="left"
                        render={(status, record) => <center>
                            <Button
                                value={1}
                                size="small"
                                style={
                                    status === 'Crédito' ? {borderColor: '#ffa940', color: '#ffa940'} :
                                    (status === 'Pago' || status === 'Recebido') ? {borderColor: `#52c41a`, color: `#52c41a`} :
                                    {borderColor: `#f5222d`, color: `#f5222d`}}>
                                {status}
                            </Button>
                        </center>}
                        filters={[{
                            text: 'A pagar',
                            value: 'A pagar'
                        }, {
                            text: 'Pago',
                            value: 'Pago'
                        },
                        {
                            text: 'Crédito',
                            value: 'Crédito'
                        },
                        {
                            text: 'Recebido',
                            value: 'Recebido'
                        },
                        ]}
                        filterMultiple={false}
                        onFilter={(value, record) => record.status && record.status.indexOf(value) === 0}
                    />
                    <Column
                        title="Cod"
                        dataIndex="cod"
                        key="cod"
                        fixed="left"
                        width={100}
                    />
                    <Column
                        title="Empresa do responsável pela indicação"
                        dataIndex="customer.name"
                        key="name"
                        fixed="left"
                        width={400}
                        render={(val, record) => record.customer && <span>{record.customer.cod} - {record.customer.name}</span>}
                    />
                    <Column
                        title="Responsável pela indicação"
                        dataIndex="refund.responsible"
                        key="refund.responsible"
                        width={320}
                    />
                    <Column
                        title="Empresa indicada"
                        dataIndex="refund.nominated_company"
                        key="nominated_company"
                        width={320}
                    />
                    <Column
                        title="Parcela"
                        dataIndex="quota"
                        key="quota"
                        width={100}
                    />
                    <Column
                        title="Método"
                        dataIndex="method"
                        key="method"
                        width={100}
                        filters={[{
                            text: payment_method(1),
                            value: 1,
                        }, {
                            text: payment_method(2),
                            value: 2,
                        },
                        {
                            text: payment_method(3),
                            value: 3,
                        },
                        {
                            text: payment_method(4),
                            value: 4,
                        }
                        ]}
                        filterMultiple={false}
                        render={val => payment_method(val)}
                        onFilter={(value, record) => record.type_staff && record.type_staff.indexOf(value) === 0}
                    />
                    <Column
                        title="Apuração"
                        dataIndex="refund.apuration_at"
                        key="refund.apuration_at"
                        width={150}
                        sorter={(a, b) => a.apuration_at && a.apuration_at.localeCompare(b.apuration_at)}
                        render={apuration_at => 
                            <center>
                            <Moment format="DD/MM/YYYY">
                                {apuration_at}
                            </Moment>
                            </center>
                        }
                    />
                    <Column
                        title="Vencimento"
                        dataIndex="due_date"
                        key="due_date"
                        width={150}
                        sorter={(a, b) => a.due_date && a.due_date.localeCompare(b.due_date)}
                        render={due_date => 
                            <center>
                            <Moment format="DD/MM/YYYY">
                                {due_date}
                            </Moment>
                            </center>
                        }
                    />
                    <Column
                        title="Valor"
                        dataIndex="amount"
                        key="amount"
                        width={200}
                        sorter={(a, b) => a.amount && (a.amount-b.amount)}
                        render={value => toBRL(value)}
                    />
                    <Column
                        title="Societário"
                        dataIndex="refund.dash_task_id"
                        key="refund.dash_task_id"
                        width={200}
                        render={value => value && (<Cod>#SOC{value}</Cod>)}
                    />
                    <Column
                        dataIndex="actions"
                        key="actions"
                        fixed="right"
                        width={150}
                        render={(text, record, index) => (
                        <center key={index}>
                            <Dropdown overlay={
                                <Menu onClick={(e) => handleMenu(e.key, record)}>
                                {user.permissions.includes(PERMISSIONS.extraServices.edit) ?
                                <Menu.Item key="edit">
                                    <Icon type="edit"></Icon> Editar
                                </Menu.Item>
                                :
                                <Menu.Item key="edit">
                                    <Icon type="file"></Icon> Detalhes
                                </Menu.Item>
                                }
                                {record.paid_at === null && (<Menu.Divider />)}
                                {record.paid_at === null && (
                                <Menu.Item key="paid">
                                    <Icon type="check"></Icon> {record.refund.type ? 'Marcar como Recebido':'Marcar como Pago'}
                                </Menu.Item>
                                )}
                                <Menu.Item>
                                    <Download url={`/refunds/payments/print/${record.id}`} filename={getFilename(record)}>
                                        <div><Icon type="printer" style={{
                                        minWidth: '12px',
                                        marginRight: '8px',
                                        fontSize: '12px'
                                        }} /> Imprimir</div>
                                    </Download>
                                </Menu.Item>
                                </Menu>
                            } trigger={['click']}>
                                <a className="ant-dropdown-link" href="#">
                                Ações <Icon type="down" />
                                </a>
                            </Dropdown>
                        </center>
                    )}
                    />
                </Table>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    user: state.user,
    data: state.refunds.payments,
    isLoading: state.refunds.isLoading
});

const mapDispatchProps = dispatch => ({
    showDrawerRefunds: (payload) => dispatch(drawerRefundsActions.show(payload)),
    setPaid: (payload) => dispatch(refundsActions.setPaid(payload)),
    loadRefunds: (filter) => dispatch(refundsActions.loadRefunds(filter))
});

export default connect(mapStateToProps, mapDispatchProps)(RefundsList);